// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 9ca3sE4gAMHXGHWcmrUodR
// Component: etl2j9Ayu-
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import InputFiled from "../../InputFiled"; // plasmic-import: yB3-yZo7Q8/component

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_main.module.css"; // plasmic-import: 9ca3sE4gAMHXGHWcmrUodR/projectcss
import sty from "./PlasmicProjectTitleEditor.module.css"; // plasmic-import: etl2j9Ayu-/css

export type PlasmicProjectTitleEditor__VariantMembers = {
  state: "_default" | "editingName" | "notStored" | "loading";
};

export type PlasmicProjectTitleEditor__VariantsArgs = {
  state?: SingleChoiceArg<"_default" | "editingName" | "notStored" | "loading">;
};

type VariantPropType = keyof PlasmicProjectTitleEditor__VariantsArgs;
export const PlasmicProjectTitleEditor__VariantProps =
  new Array<VariantPropType>("state");

export type PlasmicProjectTitleEditor__ArgsType = {
  children?: React.ReactNode;
};

type ArgPropType = keyof PlasmicProjectTitleEditor__ArgsType;
export const PlasmicProjectTitleEditor__ArgProps = new Array<ArgPropType>(
  "children"
);

export type PlasmicProjectTitleEditor__OverridesType = {
  root?: p.Flex<"div">;
  inputFiled?: p.Flex<typeof InputFiled>;
  text?: p.Flex<"div">;
};

export interface DefaultProjectTitleEditorProps {
  children?: React.ReactNode;
  state?: SingleChoiceArg<"_default" | "editingName" | "notStored" | "loading">;
  className?: string;
}

function PlasmicProjectTitleEditor__RenderFunc(props: {
  variants: PlasmicProjectTitleEditor__VariantsArgs;
  args: PlasmicProjectTitleEditor__ArgsType;
  overrides: PlasmicProjectTitleEditor__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root,
        {
          [sty.rootstate__default]: hasVariant(variants, "state", "_default"),
          [sty.rootstate_editingName]: hasVariant(
            variants,
            "state",
            "editingName"
          ),
          [sty.rootstate_notStored]: hasVariant(variants, "state", "notStored")
        }
      )}
    >
      {(
        hasVariant(variants, "state", "notStored")
          ? true
          : hasVariant(variants, "state", "editingName")
          ? true
          : true
      ) ? (
        <div
          className={classNames(projectcss.all, sty.freeBox__hFgfX, {
            [sty.freeBoxstate__default__hFgfXFwBhi]: hasVariant(
              variants,
              "state",
              "_default"
            ),
            [sty.freeBoxstate_editingName__hFgfXwpCl3]: hasVariant(
              variants,
              "state",
              "editingName"
            ),
            [sty.freeBoxstate_notStored__hFgfXuX1Pe]: hasVariant(
              variants,
              "state",
              "notStored"
            )
          })}
        >
          {(
            hasVariant(variants, "state", "loading")
              ? true
              : hasVariant(variants, "state", "editingName")
              ? true
              : true
          ) ? (
            <div
              className={classNames(projectcss.all, sty.freeBox__xZAp, {
                [sty.freeBoxstate__default__xZApFwBhi]: hasVariant(
                  variants,
                  "state",
                  "_default"
                ),
                [sty.freeBoxstate_editingName__xZApwpCl3]: hasVariant(
                  variants,
                  "state",
                  "editingName"
                ),
                [sty.freeBoxstate_loading__xZApZbkdx]: hasVariant(
                  variants,
                  "state",
                  "loading"
                )
              })}
            >
              {p.renderPlasmicSlot({
                defaultContents: "Untitled",
                value: args.children
              })}
            </div>
          ) : null}
        </div>
      ) : null}
      {(hasVariant(variants, "state", "editingName") ? true : true) ? (
        <InputFiled
          data-plasmic-name={"inputFiled"}
          data-plasmic-override={overrides.inputFiled}
          className={classNames("__wab_instance", sty.inputFiled, {
            [sty.inputFiledstate_editingName]: hasVariant(
              variants,
              "state",
              "editingName"
            )
          })}
        />
      ) : null}
      {(
        hasVariant(variants, "state", "loading")
          ? true
          : hasVariant(variants, "state", "notStored")
          ? true
          : true
      ) ? (
        <div
          className={classNames(projectcss.all, sty.freeBox__zawjf, {
            [sty.freeBoxstate_loading__zawjfZbkdx]: hasVariant(
              variants,
              "state",
              "loading"
            ),
            [sty.freeBoxstate_notStored__zawjfuX1Pe]: hasVariant(
              variants,
              "state",
              "notStored"
            )
          })}
        >
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text,
              {
                [sty.textstate_loading]: hasVariant(
                  variants,
                  "state",
                  "loading"
                ),
                [sty.textstate_notStored]: hasVariant(
                  variants,
                  "state",
                  "notStored"
                )
              }
            )}
          >
            {hasVariant(variants, "state", "loading")
              ? "Loading..."
              : "Save and Upload File"}
          </div>
        </div>
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "inputFiled", "text"],
  inputFiled: ["inputFiled"],
  text: ["text"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  inputFiled: typeof InputFiled;
  text: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicProjectTitleEditor__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicProjectTitleEditor__VariantsArgs;
    args?: PlasmicProjectTitleEditor__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicProjectTitleEditor__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicProjectTitleEditor__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicProjectTitleEditor__ArgProps,
          internalVariantPropNames: PlasmicProjectTitleEditor__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicProjectTitleEditor__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicProjectTitleEditor";
  } else {
    func.displayName = `PlasmicProjectTitleEditor.${nodeName}`;
  }
  return func;
}

export const PlasmicProjectTitleEditor = Object.assign(
  // Top-level PlasmicProjectTitleEditor renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    inputFiled: makeNodeComponent("inputFiled"),
    text: makeNodeComponent("text"),

    // Metadata about props expected for PlasmicProjectTitleEditor
    internalVariantProps: PlasmicProjectTitleEditor__VariantProps,
    internalArgProps: PlasmicProjectTitleEditor__ArgProps
  }
);

export default PlasmicProjectTitleEditor;
/* prettier-ignore-end */
